export const mutations = {
  STORE_PRODUCTS(state, products) {
    state.products = products;
  },

  STORE_PRODUCT(state, singleproducts) {
    state.singleproducts = singleproducts;
  },

  STORE_PRODUCT_UPDATE(state, productId){
      let Product = state.products.find(function(product) {
          return product.id === productId
      })
      state.systemProduct = Product
  }
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/products/mutations.js